module.exports = __webpack_public_path__ + "static/media/ระกา.43ff0c8d.jpg";